import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LogoComponent } from '../../shared/logo/logo.component';
import { RevealDirective } from '../../shared/motion/reveal.directive';
import { ThemeToggleComponent } from '../../shared/theme-toggle/theme-toggle.component';

interface PlanRow {
  readonly label: string;
  /** Gratis, Data, Pro, Equipo — en ese orden. '—' significa no incluido. */
  readonly cells: readonly string[];
}

@Component({
  selector: 'lc-landing',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RevealDirective, ThemeToggleComponent, LogoComponent],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
})
export class LandingComponent {
  protected readonly year = new Date().getFullYear();

  protected readonly planRows: readonly PlanRow[] = [
    { label: 'Búsqueda multipaís y alertas', cells: ['Sí', 'Sí', 'Sí', 'Sí'] },
    { label: 'Vigilancia de adendas', cells: ['3 procesos', 'Sí', 'Sí', 'Sí'] },
    { label: 'Checklist y control de vigencias', cells: ['—', 'Sí', 'Sí', 'Sí'] },
    { label: 'Motor de elegibilidad', cells: ['—', 'Sí', 'Sí', 'Sí'] },
    { label: 'Analítica de adjudicaciones', cells: ['—', 'Sí', 'Sí', 'Sí'] },
    { label: 'Lectura del pliego con IA', cells: ['—', '—', 'Sí', 'Sí'] },
    { label: 'Empresas licitantes', cells: ['1', '1', '3', 'Sin límite'] },
    { label: 'Usuarios', cells: ['1', 'Sin límite', 'Sin límite', 'Sin límite'] },
  ];
}
